<template>
  <div class="billing-apply">
    <GoodsInfoData :goodsInfo="goodsInfo" />

    <Form ref="form" error-message-align="right" @submit="handleFormSubmit">
      <div class="billing-info">
        <Field
          v-model="billingType"
          readonly
          input-align="right"
          name="billingType"
          label="发票类型"
          placeholder="请输入发票类型"
        />
        <Field name="headerType" label="抬头类型">
          <template #input>
            <RadioGroup
              v-model="headerType"
              direction="horizontal"
              @change="handleHeaderTypeChange"
            >
              <Radio name="1" checked-color="rgb(103, 73, 236)"
                >个人或事业单位</Radio
              >
              <Radio name="2" checked-color="rgb(103, 73, 236)">企业</Radio>
            </RadioGroup>
          </template>
        </Field>
        <Field
          v-if="!showEnterprise"
          v-model="billingHeader"
          autocomplete="off"
          input-align="right"
          name="billingHeader"
          label="发票抬头"
          :rules="[{ required: true, validator: checkBillingHeader }]"
          placeholder="请填写需要开具发票的姓名"
        />
        <div v-if="showEnterprise" class="company-billing-header">
          <Field
            v-model="companybillingHeader"
            input-align="right"
            name="companybillingHeader"
            autocomplete="off"
            label="发票抬头"
            :rules="[{ required: true }]"
            placeholder="请搜索选择需要开具发票的抬头名称"
            @blur="handleBlur"
            @input="handleCompanyBillingHeader"
          />
          <SelectList
            v-if="companyNameOptions.length && showSelectList"
            isHighLight
            :highLightText="companybillingHeader"
            :companyNameOptions="companyNameOptions"
            @change="handleCompanyChange"
          />
        </div>
        <Field
          v-if="showEnterprise"
          v-model="taxpayerNumber"
          input-align="right"
          autocomplete="off"
          :rules="[{ required: true }]"
          name="taxpayerNumber"
          label="税号"
          placeholder="请填写税号"
          :formatter="formatterTax"
          :maxlength="24"
        />
        <Field
          v-if="showEnterprise && showMore"
          v-model="companyAddress"
          input-align="right"
          name="companyAddress"
          label="企业地址"
          autocomplete="off"
          placeholder="选填"
        />
        <Field
          v-if="showEnterprise && showMore"
          v-model="companyTel"
          input-align="right"
          name="companyTel"
          autocomplete="off"
          label="企业电话"
          type="number"
          placeholder="选填"
        />
        <Field
          v-if="showEnterprise && showMore"
          v-model="depositBank"
          input-align="right"
          autocomplete="off"
          name="depositBank"
          label="开户银行"
          placeholder="选填"
        />
        <Field
          v-if="showEnterprise && showMore"
          v-model="bankAccount"
          input-align="right"
          autocomplete="off"
          name="bankAccount"
          label="银行账号"
          type="number"
          :rules="[{ validator: checkBankAccount }]"
          placeholder="选填"
          @input="handleBankAccount"
        />
        <ShowMore
          v-if="showEnterprise"
          :showMore="showMore"
          @handleMore="handleMore"
        />
      </div>
      <div class="email-address">
        <Field
          v-model="eMailAddress"
          input-align="right"
          name="eMailAddress"
          autocomplete="off"
          label="电子邮箱"
          :rules="[{ required: true, validator: checkEmail }]"
          placeholder="用于接收电子发票"
        />
      </div>
      <BillingInstruction />
      <div class="submit">
        <Button text="提交" native-type="submit" class="submit-btn" />
      </div>
    </Form>

    <ApplyConfirm
      v-model="showConfirmPop"
      :displayField="formdata"
      :headerType="headerType"
      @comfirmApply="comfirmApply"
    >
      <template v-slot:title> 开具电子发票 </template>
      <template slot="tips">
        <div class="pop-tips">请确认开票信息，发票开具后不可更改</div>
      </template>
      <template v-slot:content="{ list, sliceNumber, showEnterpriseMore }">
        <div class="pop-content" :class="{ clear_mar_bm: showEnterprise }">
          <div
            v-for="item in list.slice(0, sliceNumber)"
            :key="item.fileldText"
            class="content-item"
          >
            <div class="label">{{ item.fileldText }}</div>
            <div class="text">{{ item.value || '-' }}</div>
          </div>
        </div>

        <ShowMore
          v-if="showEnterprise"
          :showMore="sliceNumber === 8"
          @handleMore="showEnterpriseMore"
        />
      </template>
      <template v-slot:footer="{ handleClickSubmit }">
        <Button
          class="confirm-btn"
          text="确认提交"
          @click="handleClickSubmit"
        ></Button>
      </template>
    </ApplyConfirm>
  </div>
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator';
import GoodsInfoData from '../../common/GoodsInfo.vue';
import Button from '../../common/Button.vue';
import Form from 'vant/lib/form';
import Field from 'vant/lib/field';
import RadioGroup from 'vant/lib/radio-group';
import Radio from 'vant/lib/radio';
import ApplyConfirm from './components/ApplyConfirm.vue';
import SelectList from './components/SelectList.vue';
import BillingSystemMixins from '../../mixin/mixins';
import ShowMore from '../../common/ShowMore.vue';
import BillingInstruction from '../../common/BillingInstructions.vue';
import { promiseLock } from '@/lib/decorates';
import Toast from 'vant/lib/toast';
import 'vant/lib/toast/style';
import {
  ISelectList,
  IGoodsInfo,
  headerTypeObject,
  EOperate,
  headerTypeEnum,
  IBillingApply,
  aliveComponentsEnum,
  resStatusEnum,
  IBillingDetail,
  statusEnum,
  statusForComponents,
  billingStatusObject,
} from '../../billingSystem';
import { Route } from 'vue-router';
import { getCookie } from '@lib/util';
import Axios from 'axios';
import { v4 as uuidV4 } from 'uuid';
import * as Sentry from '@sentry/vue';

const prefix = `invoice` + (window.ENV_BRANCH || '');

import 'vant/lib/form/style';
import 'vant/lib/field/style';
import 'vant/lib/radio-group/style';
import 'vant/lib/radio/style';

@Component({
  components: {
    GoodsInfoData,
    Form,
    Field,
    Radio,
    RadioGroup,
    Button,
    ApplyConfirm,
    SelectList,
    ShowMore,
    BillingInstruction,
  },
  beforeRouteEnter(to: Route, from: Route, next: Function) {
    if (
      from.name !== aliveComponentsEnum.billingErrorNetwork &&
      from.name !== aliveComponentsEnum.billingErrorRefunded
    ) {
      window.localStorage.removeItem('inputInfo');
    }
    next(async (vm: BillingApply) => {
      window.Al.start();
      window.np.start();
      await vm.getInvoiceOrderSingle();
      await vm.getOrderDetail();
      window.Al.done();
      window.np.done();
    });
  },
})
export default class BillingApply extends Mixins(BillingSystemMixins) {
  source: any;
  goodsInfo: IGoodsInfo = {
    goodsName: '',
    goodsOrderCode: '',
    goodsOrderTime: 0,
    goodsOrderMoney: 0,
    goodsInvoiceAmount: 0,
  };
  billingType = '普通电子发票';
  headerType: string = headerTypeObject.personal;
  // 个人相关
  billingHeader: any = null;
  // 企业相关
  companybillingHeader: any = null;
  taxpayerNumber: any = null;
  companyTel: any = null;
  companyAddress = '';
  bankAccount = '';
  depositBank = '';
  eMailAddress = '';
  // 确认提交
  formdata: IBillingApply = {
    headerType: '',
    invoice_amount: 0,
    invoice_type: '',
    title_name: '',
    email: '',
    tax_code: '',
    organization_address: '',
    organization_tel: '',
    bank_name: '',
    bank_account: '',
  };
  showMore: Boolean = false;
  showConfirmPop: Boolean = false;
  showSelectList: Boolean = false;
  intervalId: any = null;
  companyNameOptions: ISelectList[] = [];
  billingDetail: IBillingDetail = {
    id: 1,
    state: statusEnum.committed,
    invoice_status: 1,
    pay_amount: 0,
    paid_time: 1,
    invoice_amount: 1,
    production_name: '',
    apply_time: 1,
    invoice_time: 1,
    title_type: '',
    title_name: '',
    tax_code: '',
    email: '',
    organization_address: '',
    organization_tel: '',
    bank_name: '',
    bank_account: '',
    order_no: '',
    order_id: '',
    card_status: 1,
    we_chat_card_url: '',
  };
  get showEnterprise() {
    return this.headerType === headerTypeObject.enterprise;
  }
  handleBlur() {
    this.showSelectList = false;
  }
  handleMore() {
    this.showMore = !this.showMore;
  }
  handleBankAccount(value: string) {
    if (!value) return;
    let str = String(value);
    if (str.length > 30) {
      str = str.substring(0, 30);
    }
    this.bankAccount = this.utilHandleStr(str);
  }
  handleCompanyBillingHeader(value: string) {
    // this.taxpayerNumber = null;
    if (value) {
      this.showSelectList = true;
      if (this.intervalId) {
        clearTimeout(this.intervalId);
      }
      this.intervalId = setTimeout(() => {
        this.getCompanyNameOptions(value);
      }, 100);
    } else {
      this.showSelectList = false;
    }
  }
  cancelRequest() {
    if (typeof this.source === 'function') {
      this.source('cancel-requset');
    }
  }
  async getCompanyNameOptions(value: string) {
    this.cancelRequest();
    const {
      data: { data },
    } = await Axios.get(`${(window as any).host}/${prefix}/enterprise-name`, {
      params: {
        keyword: value,
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getCookie('token')}`,
      },
      cancelToken: new Axios.CancelToken((source) => {
        this.source = source;
      }),
    });

    try {
      if (data && Array.isArray(data) && !!data.length) {
        this.companyNameOptions =
          data.map((item: ISelectList) => ({
            ...item,
            uuid: uuidV4(),
          }))
      } else {
        this.companyNameOptions = []
      };
    } catch (err) {
      console.log(`getCompanyNameOptions Error: ${(err as any)?.message}`)
      Sentry.setContext(`CompanyNameOptions`, {
        url: `${(window as any).host}/${prefix}/enterprise-name`, 
        value: JSON.stringify(data)}
      )
      Sentry.setContext('fc-user', {
        token: getCookie('token'),
      })
      Sentry.captureMessage('getCompanyNameOptions Error', {
        level: 'fatal'
      })
    }
  }
  async handleCompanyChange({ id, name }: ISelectList) {
    this.showSelectList = false;
    this.companybillingHeader = name;
    const {
      data: { uncid },
    } = await window.apis.getEnterpriseTicket({ id });
    this.taxpayerNumber = this.utilHandleStr(uncid);
  }
  resetEnterPriseInfo() {
    this.taxpayerNumber = null;
    this.companyAddress = '';
    this.companyTel = null;
    this.bankAccount = '';
    this.depositBank = '';
    this.companybillingHeader = null;
  }
  resetPersonInfo() {
    this.billingHeader = null;
  }
  checkAddressTel() {
    if (
      String(this.companyAddress).length + String(this.companyTel).length >
      50
    ) {
      return false;
    }
    return true;
  }
  handleFormSubmit() {
    if (this.headerType === headerTypeObject.personal) {
      this.formdata = {
        invoice_amount: this.goodsInfo.goodsInvoiceAmount, // 开票金额
        invoice_type: 'electronic',
        title_name: this.billingHeader, // 公司抬头
        email: this.eMailAddress, // 邮箱
        headerType: this.headerType,
      };
    } else {
      if (!this.checkAddressTel()) {
        return Toast({
          className: 'billing-toast',
          forbidClick: false,
          message: '地址和电话加起来需要小于50个字',
        });
      }
      this.formdata = {
        headerType: this.headerType,
        invoice_amount: this.goodsInfo.goodsInvoiceAmount,
        invoice_type: 'electronic',
        title_name: this.companybillingHeader,
        email: this.eMailAddress,
        tax_code: this.taxpayerNumber,
        organization_address: this.companyAddress,
        organization_tel: this.companyTel,
        bank_name: this.depositBank,
        bank_account: this.bankAccount,
      };
    }
    this.showConfirmPop = true;
  }
  comfirmApply() {
    this.postInvoiceInvoicesApply(this.formdata);
  }
  handleEditType(state: statusEnum) {
    return billingStatusObject[state].editType;
  }
  async handlePostAdd(params: any) {
    try {
      const { data } = await window.apis.postInvoiceInvoicesApply(params);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject();
    }
  }
  async handlePostEdit(params: any) {
    try {
      const { data } = await window.apis.postInvoiceInvoicesEdit(params);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject();
    }
  }
  @promiseLock
  async postInvoiceInvoicesApply(applyform: IBillingApply) {
    const { id, type } = this.getUrlParams();
    const params = {
      ...applyform,
      tax_code: this.handleStrSpace(applyform.tax_code),
      bank_account: this.handleStrSpace(applyform.bank_account),
      title_type:
        applyform.headerType === headerTypeObject.enterprise
          ? headerTypeEnum.enterprise
          : headerTypeEnum.personal,
      order_id: Number(id),
    };
    delete params.headerType;
    let otherParams = {};
    if (type === EOperate.edit) {
      otherParams = {
        order_id: Number(this.billingDetail.order_id),
        order_no: this.billingDetail.order_no,
        type: this.handleEditType(this.billingDetail.state),
      };
    }

    const postMethod =
      type === EOperate.edit ? this.handlePostEdit : this.handlePostAdd;

    try {
      const { status } = await postMethod({ ...params, ...otherParams });
      const name = statusForComponents[status as resStatusEnum];
      this.handleRouteLinkTo(name, {
        type,
        id,
      });
    } catch (error) {
      this.handleLocalstorage(this.formdata);
      this.handleRouteLinkTo('billingErrorNetwork', {
        type,
        id,
      });
    }
  }
  handleHeaderTypeChange(headerType: string) {
    headerType === headerTypeObject.enterprise
      ? this.resetPersonInfo()
      : this.resetEnterPriseInfo();
    if (headerType !== headerTypeObject.enterprise && this.showMore) {
      this.showMore = false;
    }
  }
  checkBankAccount(bankAccount: number) {
    const bankNo_pattern = /^\d{8,30}$/;
    const _bankNo = bankAccount && String(bankAccount).replace(/[\s]/g, '');
    if (!_bankNo) {
      return true;
    }
    return bankNo_pattern.test(_bankNo);
  }
  checkBillingHeader(billingHeader: string) {
    return billingHeader && this.getStrLen(billingHeader) >= 4;
  }
  initLocalstrageData() {
    if (this.$route.params.type === EOperate.edit) return;
    const inputInfo = window.localStorage.getItem('inputInfo');
    if (!inputInfo) return;
    const info = JSON.parse(inputInfo);
    this.initInputData(info);
  }
  initInputData({
    headerType,
    tax_code,
    organization_address,
    organization_tel,
    bank_account,
    bank_name,
    title_name,
    email,
  }: IBillingApply) {
    this.headerType = headerType || '';
    if (headerType === headerTypeObject.enterprise) {
      this.taxpayerNumber = this.utilHandleStr(tax_code);
      this.companyAddress = organization_address || '';
      this.companyTel = organization_tel;
      this.bankAccount = this.utilHandleStr(bank_account);
      this.depositBank = bank_name || '';
      this.companybillingHeader = title_name;
    } else {
      this.billingHeader = title_name;
    }
    this.eMailAddress = email || '';
  }
  async getOrderDetail() {
    const { id, type } = this.getUrlParams();
    if (type === EOperate.add) return;
    const params = {
      OrderId: id,
    };
    try {
      const { data } = await window.apis.getInvoiceDetail(params);
      this.billingDetail = data;
      this.initInputData({
        ...data,
        headerType: headerTypeObject[data.title_type as headerTypeEnum],
      });
    } catch (error) {
      console.log('error', error);
    }
  }
  mounted() {
    this.initLocalstrageData();
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/index.scss';
.billing-apply {
  padding: 24px 32px 136px;
  background-color: $_app_backgroup;
  .company-billing-header {
    position: relative;
  }
  .company-billing-header::after {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    border: 1px solid $_reset_gray;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    content: ' ';
    pointer-events: none;
  }
  .email-address {
    @include common;
  }
  .submit {
    @include fixed_nav(bottom, 136px, $_white_color, 0, center);
  }
  .confirm-btn,
  .submit-btn {
    background: $_base_light_purple;
  }
  .pop-content {
    padding: 32px 0 0;
    .content-item {
      display: flex;
      margin-bottom: 32px;
      .label {
        min-width: 128px;
        margin-right: 32px;
        color: #ada9be;
        font-size: 28px;
        font-family: $_reg_famliy;
      }
      .text {
        color: $_base_color;
        font-weight: 500;
        font-size: 28px;
        font-family: $_med_famliy;
      }
    }
  }
  .pop-content.clear_mar_bm {
    .content-item:last-of-type {
      margin-bottom: 0;
    }
  }
  .show-more {
    color: $_gray_color;
    text-align: center;
  }
}
</style>

<style lang='scss' >
@import '../../style/index.scss';
.billing-apply {
  .van-cell {
    padding: 32px 0;
    font-size: 28px;
    .van-field__label {
      width: 166px;
      margin-right: 0;
      color: $_base_color !important;
    }
  }
  .van-cell::after {
    right: 0;
    left: 0;
    border: 1px solid $_reset_gray;
  }
  .billing-info {
    @include common;
    .van-field__control {
      justify-content: flex-end;
      .van-radio--horizontal {
        margin-right: 40px;
      }
      .van-radio--horizontal:last-of-type {
        margin-right: 0;
      }
    }
  }
}
</style>